import { createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../../../utils/enums';

const initialState = {
  // Rails data
  rails: [],
  railsStatus: RequestStatus.IDLE,
  railsError: null,

  // Current selected rail
  selectedRail: null,

  // Rail events
  railEvents: [],
  railEventsStatus: RequestStatus.IDLE,
  railEventsError: null,

  // Timeline data
  timelineData: null,
  timelineStatus: RequestStatus.IDLE,
  timelineError: null,

  // Current video state
  currentTime: 0,
  videoDuration: 0,
  isPlaying: false,

  // Create/Update/Delete operations
  createEventStatus: RequestStatus.IDLE,
  createEventError: null,
  updateEventStatus: RequestStatus.IDLE,
  updateEventError: null,
  deleteEventStatus: RequestStatus.IDLE,
  deleteEventError: null,

  // Submit data
  submitStatus: RequestStatus.IDLE,
  submitError: null,
  submitResult: null,
};

const railsSlice = createSlice({
  name: 'rails',
  initialState,
  reducers: {
    // Rails data
    fetchRailsStart: (state) => {
      state.railsStatus = RequestStatus.LOADING;
      state.railsError = null;
    },
    fetchRailsSuccess: (state, action) => {
      state.railsStatus = RequestStatus.SUCCEEDED;
      state.rails = action.payload;
      state.railsError = null;
    },
    fetchRailsFailure: (state, action) => {
      state.railsStatus = RequestStatus.FAILED;
      state.railsError = action.payload;
    },
    // Submit rail data
    submitRailDataStart: (state) => {
      state.submitStatus = RequestStatus.LOADING;
      state.submitError = null;
    },
    submitRailDataSuccess: (state, action) => {
      state.submitStatus = RequestStatus.SUCCEEDED;
      state.submitResult = action.payload;
      state.submitError = null;
    },
    submitRailDataFailure: (state, action) => {
      state.submitStatus = RequestStatus.FAILED;
      state.submitError = action.payload;
    },

    // Reset submit status
    resetSubmitStatus: (state) => {
      state.submitStatus = RequestStatus.IDLE;
      state.submitError = null;
      state.submitResult = null;
    },

    // Fetch GPS data
    fetchRailGpsDataStart: (state) => {
      state.railsStatus = RequestStatus.LOADING;
      state.railsError = null;
    },
    fetchRailGpsDataSuccess: (state, action) => {
      state.railsStatus = RequestStatus.SUCCEEDED;
      state.rails = action.payload;
      state.railsError = null;
    },
    fetchRailGpsDataFailure: (state, action) => {
      state.railsStatus = RequestStatus.FAILED;
      state.railsError = action.payload;
    },
  },
});

export const {
  fetchRailsStart,
  fetchRailsSuccess,
  fetchRailsFailure,
  fetchRailGpsDataStart,
  fetchRailGpsDataSuccess,
  fetchRailGpsDataFailure,
  submitRailDataStart,
  submitRailDataSuccess,
  submitRailDataFailure,
  resetSubmitStatus,
} = railsSlice.actions;

export default railsSlice.reducer;
